import { IconButton } from "@material-ui/core";
import * as React from "react";
import { TrashIcon } from "src/documentUpload/TrashIcon";
import { RuleChangeLogItem } from "src/spread/model/spread/types";
import "./RuleCard.scss";

interface RuleCardProps {
  rule: RuleChangeLogItem;
  openDeleteRuleModal: (rule: RuleChangeLogItem) => void;
}

export class RuleCard extends React.Component<RuleCardProps> {
  constructor(props: RuleCardProps) {
    super(props);
  }

  public render() {
    const {
      fromParentNodeName,
      toParentNodeName,
      accountName,
      timestamp,
      userId
    } = this.props.rule;

    return (
      <div className="RuleCard">
        <div className="RuleCard__content">
          <div className="RuleCardRow">
            <div className="RuleCardRow__content">
              <span className="RuleCardRow__content__title">Remap: </span>
              <span className="RuleCardRow__content__name">{accountName}</span>
            </div>
            <div className="RuleCardRow__content">
              <span className="RuleCardRow__content__secondary">
                Created by: {userId}
              </span>
            </div>
          </div>
          <div className="RuleCardRow">
            <div className="RuleCardRow__content">
              <span className="RuleCardRow__content__title">From: </span>
              <span className="RuleCardRow__content__name">
                {fromParentNodeName}
              </span>
            </div>
            <div className="RuleCardRow__content">
              <span className="RuleCardRow__content__secondary">
                Last Updated: {timestamp}
              </span>
            </div>
          </div>
          <div className="RuleCardRow">
            <div className="RuleCardRow__content">
              <span className="RuleCardRow__content__title">To: </span>
              <span className="RuleCardRow__content__name">
                {toParentNodeName}
              </span>
            </div>
          </div>
        </div>
        <div className="RuleCard__delete__container">
          <IconButton
            className="RuleCard__delete__button"
            children={<TrashIcon />}
            color={"inherit"}
            onClick={this.handleDeleteRuleClick}
          />
        </div>
      </div>
    );
  }

  private handleDeleteRuleClick = () => {
    this.props.openDeleteRuleModal(this.props.rule);
  };
}



// WEBPACK FOOTER //
// ./src/ruleView/RuleCard.tsx